import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";


export const fetchtodo = createAsyncThunk('todos', async () =>{
    const res = await axios.get('https://jsonplaceholder.typicode.com/posts')
    return res.data;
})


const todoslice = createSlice({
    name:'todo',
    initialState:{
        loading:false,
        error:null,
        data:null,
        issucess:false,
        isError:false,
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(fetchtodo.fulfilled,(state,action)=>{
            state.loading = false;
            state.error = false;
            state.data = action.payload;
            state.isError = false;
            state.issucess = true;
        })
        .addCase(fetchtodo.rejected,(state,action)=>{
            state.loading = false;
            state.error = action.payload || action.error.message;
            state.data = null;
            state.isError = true;
            state.issucess = false;
        })
        .addCase(fetchtodo.pending,(state)=>{
            state.loading = true;
            state.error = null;
            state.data = null;
            state.issucess = false;
            state.isError = false;
        })
    }
})


export default todoslice.reducer;